import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=6f84514d&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=6f84514d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84514d",
  null
  
)

export default component.exports